import { render } from "./CategoryCard.vue?vue&type=template&id=23665f55"
import script from "./CategoryCard.js?vue&type=script&lang=js"
export * from "./CategoryCard.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__